export const AUTHENTICATION_SIGNOUT = 'authentication/SIGNOUT_SUCCESS'
export const AUTHENTICATION_SUCCESS = 'authentication/SIGNIN_SUCCESS'
export const AUTHENTICATION_FAILURE = 'authentication/SIGNIN_ERROR'
export const EXPIRED_SESSION_FAILURE = 'authentication/SESSION_ERROR'
